function arrive(selector, callback) {
  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        const element = document.querySelector(selector);
        if (
          element &&
          element.shadowRoot &&
          element.shadowRoot.querySelector("#root")
        ) {
          callback(element.shadowRoot);
          observer.disconnect();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function deliveryPromiseStyles() {
  if (!document.body.classList.contains("template-product")) return;

  const selector = "delivery-promise-container";

  const styleElement = document.createElement("style");

  const cssText = `
    @media (max-width: 768px) {
      #ddp-expiry-label,
      #ddp-date,
      #ddp-expiry,
      #ddp-zipcode-label{
        font-size: 12px;
      }
      .grid-container {
        min-width: unset;
      }
    }
    @media (min-width: 768px) {
      delivery-promise-container{
        margin-left: 120px;
        width: 100%;
      }
    }
    @media (min-width: 1200px) {
      delivery-promise-container {
        margin-left: 120px;
      }
    }
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      #ddp-expiry-label, #ddp-date, #ddp-expiry, #ddp-zipcode-label {
        font-size: 10px !important;
      }
    }
    .grid-container {
       background: transparent;
    }
    `;

  styleElement.textContent = cssText;

  arrive(selector, (shadowRoot) => {
    shadowRoot.appendChild(styleElement);
  });
}

document.addEventListener('DOMContentLoaded', deliveryPromiseStyles);
